module.exports = __webpack_public_path__ + "static/media/facebook.e7187409.png";